;(function() {
    'use strict';

    /**
     * @ngdoc object
     * @name d7-services.commons.directives:Directives
     * @description
     * This module bundles all modules related to the commons directives
     * @requires d7-services.commons.directives.toggleByAccesslevel:toggleByAccesslevel
     */
    angular.module('d7-services.commons.directives', 
    		['d7-services.commons.directives.toggleByAccesslevel']);

})();